import * as yup from "yup";

export const emailValidationSchema = yup
  .string()
  .required("Email Address is required")
  .email("Please enter a valid email address");
